import React from 'react';
import {useSelector} from 'react-redux';
import PageButton from '../PageButton/PageButton';
import {checkIfHasIncompleteQuests} from '../../../configs/quests';
import './QuestsButton.css';

/**
 * Есть ли у игрока невыполненные ДОСТУПНЫЕ задания. От этого зависит вид
 * кнопки «Задания» (см. QuestsButton), а в профиле — еще и ее место на
 * странице: пока есть что выполнять, она висит вверху, над основной
 * информацией
 */
export const useHasIncompleteQuests = () => {
  const completedTutorialChapters = useSelector((state) => state.private.auth.completedTutorialChapters);
  const completedQuests = useSelector((state) => state.private.auth.completedQuests);

  return checkIfHasIncompleteQuests({completedTutorialChapters, completedQuests});
};

/**
 * Кнопка перехода на страницу заданий — одна на все места, где она
 * встречается (профиль, модалка «Недостаточно фракций»). Пока есть
 * невыполненные задания, она выделена цветом и пульсирующим значком
 * восклицательного знака; когда все выполнено — обычная кнопка меню
 */
const QuestsButton = ({pageId, buttonId = 'quests', className, onClick}) => {
  const hasIncompleteQuests = useHasIncompleteQuests();

  return (
    <PageButton
      className={[
        'quests-button',
        hasIncompleteQuests ? 'quests-button_attention' : '',
        className || '',
      ].filter(Boolean).join(' ')}
      onClick={onClick}
      pageId={pageId}
      buttonId={buttonId}
    >
      Задания
    </PageButton>
  );
};

export default QuestsButton;
